module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-footer"
    }
  }, [_c('section', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "row text-center text-xs-center text-sm-left text-md-left"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-center"
  }, [_c('h5', [_vm._v("Contact")]), _vm._v(" "), _c('div', [_vm._v("\n            Contacter le Dr Ryan Saad\n        ")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ContactPage'
      }
    }
  }, [_vm._v("\n              en cliquant ici\n          ")])], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-center"
  }, [_c('h5', [_vm._v("Adresse")]), _vm._v(" "), _c('div', [_vm._v("\n            Clinique Sainte Genevieve\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            29 Rue Sarrette, 75014 Paris\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-center"
  }, [_c('h5', [_vm._v("Prise de RDV")]), _vm._v(" "), _c('div', [_vm._v("\n            Téléphone: "), _c('span', {
    attrs: {
      "href": "tel:0156535858"
    }
  }, [_vm._v("01 56 53 58 58")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.doctolib.fr/dentiste/paris/ryan-saad"
    }
  }, [_vm._v("RDV depuis Doctolib, cliquez ici")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "copyright-section"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 mt-2 text-center"
  }, [_c('p', [_vm._v("Copyright © 2020 - Dr Ryan Saad")])]), _vm._v(" "), _c('hr')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-232871ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232871ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/global/pageFooter/pageFooter.component.html
// module id = 263
// module chunks = 1